import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import Loader from "../components/Loader";

const API_BASE = `${BASE_URL}api/export`;

const BenOngage = () => {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE}/benongage-count`)
      .then((res) => {
        if (typeof res.data.count === "number") {
          setCount(res.data.count);
        } else {
          setCount("Error");
        }
      })
      .catch((err) => {
        setCount("Error");
        // Log error for debugging
        console.error("Ben Ongage count fetch error:", err, err?.response?.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDownloadCSV = async () => {
    setDownloading(true);
    try {
      const response = await axios.get(`${API_BASE}/benongage-records-csv`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "benongage-data.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Failed to download CSV file.");
      // Optionally log error
      console.error("CSV download error:", err, err?.response?.data);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="container py-4 mytasks-bg">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Ben Ongage Data Overview</h2>
        <button
          className="btn btn-primary"
          onClick={handleDownloadCSV}
          disabled={loading || downloading}
        >
          {downloading ? "Downloading..." : "Download CSV"}
        </button>
      </div>
      {downloading && <Loader message="Preparing CSV file..." />}
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <p className="mb-4 text-muted">
            This page displays the total number of records in the{" "}
            <strong>tblRefinance</strong> table where{" "}
            <span>the NID is greater than or equal to 1,873,672</span>.
          </p>
          {loading ? (
            <Loader message="Loading count..." />
          ) : (
            <div
              className="d-flex align-items-center"
              style={{ fontSize: "1.5rem" }}
            >
              <span className="me-2" style={{ fontWeight: 500 }}>
                Total Records:
              </span>
              <span
                style={{ color: "#007bff", fontWeight: 700 }}
              >
                {count !== null && count !== "Error"
                  ? count
                  : "Unavailable"}
              </span>
            </div>
          )}
        </div>
      </div>
      <style>{`
        .mytasks-bg { background: #f1f3f5; position: relative; min-height: 80vh; }
        .card {
          border-radius: 0.5rem;
        }
        h2 {
          font-size: 2rem;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default BenOngage;
